import {Dispatch, FC, SetStateAction, useState} from 'react'
import {Accordion, Alert, Button, Col, Form, Row} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {IForm, IPerson} from '../oneQuoteTypes'
import {useNavigate} from 'react-router-dom'
import {GENDER_OPTIONS, INIT_PEOPLE} from '../../../helpers/consts'
import {genderLabel as catalogGenderLabel} from '../../../helpers/catalogMessages'
import {calculateAge, getYearFromEffectiveDate} from '../../../helpers'
import { DateInput } from 'app/tfi/components/DateInput'

interface IAccorProps {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  formData: IForm
  setFormData: Dispatch<SetStateAction<IForm>>
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  arrPeople: IPerson[]
  setArrPeople: Dispatch<SetStateAction<IPerson[]>>
  infoEnrollement: {
    id: null | number
    effectiveDate: string
    planId: string
    usesTobacco: boolean
  }
  setInfoEnrollement: Dispatch<
    SetStateAction<{
      id: null | number
      effectiveDate: string
      planId: string
      usesTobacco: boolean
    }>
  >
  hasSetInitialRanges: React.MutableRefObject<boolean>
}

export const AccordionForm: FC<IAccorProps> = ({
  handleSubmit,
  formData,
  setFormData,
  handleChange,
  arrPeople,
  setArrPeople,
  infoEnrollement,
  setInfoEnrollement,
  hasSetInitialRanges,
}) => {
  const navigate = useNavigate()
  const intl = useIntl()
  const hash = '#'

  const [showMore, setShowMore] = useState(false)
  const handleAddPeople = () => {
    setArrPeople((p) => [
      ...p,
      {
        id: Date.now() + Math.random(),
        ...INIT_PEOPLE,
      },
    ])
  }

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    hasSetInitialRanges.current = false
    handleSubmit(e)
  }

  // console.log('AFORM arrPeople', arrPeople)
  // console.log('infoEnrollement', infoEnrollement)

  return (
    <Accordion>
      <Accordion.Item eventKey='0'>
        <Accordion.Header>
          <FormattedMessage id='quotes.household.title' defaultMessage='Household Form' />
        </Accordion.Header>
        <Accordion.Body>
          <Form onSubmit={handleSearch}>
            <div>
              <Alert variant='primary' className='my-5 d-flex align-items-center gap-2'>
                <span>
                  <i className='bi bi-exclamation-circle fs-1' style={{color: 'inherit'}} />
                </span>
                <FormattedMessage
                  id='quotes.household.alert'
                  defaultMessage='Please fill in the necessary information below to receive a quote for insurance plans.'
                />
              </Alert>
              {formData && (
                <Row>
                  <Col lg={3} md={6} sm={12} xs={12}>
                    <Form.Group>
                      <Form.Label>
                        <FormattedMessage id='quotes.household.income' defaultMessage='Household Income' />
                      </Form.Label>
                      <Form.Control
                        type='text'
                        name='householdIncome'
                        value={formData.householdIncome}
                        onChange={(e) => {
                          const {value} = e.target
                          const noComma = value.replaceAll(',', '')
                          if (noComma !== '' && isNaN(Number(noComma))) return
                          const str = Intl.NumberFormat('en-US').format(Number(noComma))
                          setFormData((p) => ({...p, householdIncome: str}))
                        }}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={2} md={2} sm={6} xs={6}>
                    <Form.Group>
                      <Form.Label title={intl.formatMessage({id: 'quotes.household.membersTooltip', defaultMessage: 'People in their tax household'})}>
                        <FormattedMessage id='quotes.household.numberOfMembers' defaultMessage='Number of Members' />
                      </Form.Label>
                      <Form.Control
                        type='number'
                        name='numberOfMembers'
                        value={formData.numberOfMembers}
                        required
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            numberOfMembers: e.target.value,
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  {/* <Col lg={1} md={1} sm={3} xs={3}>
                    <Form.Group>
                      <Form.Label>Zip Code</Form.Label>
                      <input
                        type='text'
                        name='countyfips'
                        value={formData.zipCode ?? ''}
                        onChange={handleChange}
                        className='form-control form-control-border-less'
                      />
                    </Form.Group>
                  </Col> */}
                  <Col lg={4} md={6} sm={12} xs={12}>
                    <Form.Group>
                      <Form.Label>
                        <FormattedMessage id='quotes.household.countyStateZip' defaultMessage='County / State / Zip Code' />
                      </Form.Label>
                      <input
                        type='text'
                        name='countyfips'
                        value={formData.countyfipsName ?? ''}
                        onChange={handleChange}
                        className='form-control form-control-border-less'
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={3} md={6} sm={12} xs={12}>
                    <Form.Group>
                      <Form.Label>
                        <FormattedMessage id='quotes.detail.form.effectiveDate' defaultMessage='Effective date' />
                      </Form.Label>
                      <DateInput
                        id='effectiveDate'
                        name='effectiveDate'
                        value={formData.effectiveDate ?? ''}
                        onChange={(_, value) =>
                          setFormData((p) => ({
                            ...p,
                            effectiveDate: value,
                            year: getYearFromEffectiveDate(value),
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              <hr />
              <div>
                {/* Tabla para mostrar los miembros */}
                <div className='mt-4 table-scrollable table-container table-members'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <h5 className='mb-3'>
                      <FormattedMessage id='common.field.members' defaultMessage='Members' />
                    </h5>
                    <Button variant='link' size='sm' onClick={() => setShowMore((prev) => !prev)}>
                      {showMore
                        ? intl.formatMessage({id: 'quotes.household.showLess', defaultMessage: 'Show less'})
                        : intl.formatMessage({id: 'quotes.household.showMore', defaultMessage: 'Show more'})}
                    </Button>
                  </div>
                  <table className='w-100 table-scrollable table-scroll table-light table-striped table-sm'>
                    <thead>
                      <tr role='row'>
                        <th className='fw-bold'>{hash}</th>
                        <th className='fw-bold'><FormattedMessage id='common.field.dateOfBirth' defaultMessage='Date of Birth' /></th>
                        <th className='fw-bold'><FormattedMessage id='quotes.household.age' defaultMessage='Age' /></th>
                        <th className='fw-bold'><FormattedMessage id='common.field.gender' defaultMessage='Gender' /></th>
                        <th className='fw-bold'><FormattedMessage id='quotes.household.usesTobacco' defaultMessage='Uses Tobacco' /></th>
                        <th className='fw-bold'><FormattedMessage id='quotes.household.isPregnant' defaultMessage='Is Pregnant' /></th>
                        <th className='fw-bold show-more'><FormattedMessage id='quotes.household.aptcEligible' defaultMessage='APTC Eligible' /></th>
                        {showMore && (
                          <>
                            <th className='fw-bold show-more'><FormattedMessage id='quotes.household.isParent' defaultMessage='Is Parent' /></th>
                            <th className='fw-bold show-more'><FormattedMessage id='quotes.household.hasMec' defaultMessage='Has MEC' /></th>
                          </>
                        )}
                        <th className='fw-bold'><FormattedMessage id='common.field.actions' defaultMessage='Actions' /></th>
                      </tr>
                    </thead>
                    {formData && (
                      <tbody>
                        {/* Mostrar el primer miembro (personOne) */}
                        <tr>
                          <td>{1}</td>
                          <td>
                            {formData && formData.personOne && (
                              <DateInput
                                id='dobPersonOne'
                                name='dob'
                                required={Boolean(
                                  !formData.personOne.age && !formData.personOne.dob
                                )}
                                value={formData.personOne.dob}
                                onChange={(_, value) => {
                                  if (!value) {
                                    setFormData((p) => ({
                                      ...p,
                                      personOne: {...p.personOne, dob: '', age: ''},
                                    }))
                                    return
                                  }
                                  const age = calculateAge(value)
                                  setFormData((p) => ({
                                    ...p,
                                    personOne: {
                                      ...p.personOne,
                                      dob: value,
                                      age: age ? `${age}` : '',
                                      hasMec: age && Number(age) < 19 ? true : false,
                                    },
                                  }))
                                }}
                              />
                            )}
                          </td>
                          <td>
                            {formData && formData.personOne && (
                              <Form.Control
                                className='input-age'
                                required={Boolean(
                                  !formData.personOne.age && !formData.personOne.dob
                                )}
                                type='number'
                                name='Age'
                                disabled={Boolean(formData.personOne.dob)}
                                value={formData.personOne.age ?? 0}
                                onChange={(e) => {
                                  const { value } = e.target
                                  if (value === '') {
                                    setFormData((p) => ({
                                      ...p,
                                      personOne: { ...p.personOne, age: '' },
                                    }))
                                    return
                                  }
                                  if (isNaN(Number(value))) return

                                  setFormData((p) => ({
                                    ...p,
                                    personOne: {
                                      ...p.personOne,
                                      age: value,
                                      hasMec: Number(value) < 19 ? true : false, // 👈 fuerza MEC si la edad < 19
                                    },
                                  }))
                                }}
                              />
                            )}
                          </td>
                          <td>
                            {formData && formData.personOne && (
                              <Form.Control
                                required
                                className='input-gender'
                                as='select'
                                name='gender'
                                value={formData.personOne.gender}
                                onChange={(e) => {
                                  setFormData((p) => ({
                                    ...p,
                                    personOne: {...p.personOne, gender: e.target.value},
                                  }))
                                }}
                              >
                                {GENDER_OPTIONS.map(({value, label}) => (
                                  <option key={value} value={value}>
                                    {catalogGenderLabel(intl, value, label)}
                                  </option>
                                ))}
                              </Form.Control>
                            )}
                          </td>
                          <td>
                            {formData && formData.personOne && (
                              <Form.Check
                                type='switch'
                                name='usesTobacco'
                                id='usesTobacco'
                                checked={formData.personOne.usesTobacco}
                                onChange={(e) => {
                                  setFormData((p) => ({
                                    ...p,
                                    personOne: {...p.personOne, usesTobacco: e.target.checked},
                                  }))
                                }}
                              />
                            )}
                          </td>
                          <td>
                            {formData && formData.personOne && (
                              <Form.Check
                                type='switch'
                                name='isPregnant'
                                id='isPregnant'
                                checked={formData.personOne.isPregnant}
                                onChange={(e) => {
                                  setFormData((p) => ({
                                    ...p,
                                    personOne: {...p.personOne, isPregnant: e.target.checked},
                                  }))
                                }}
                              />
                            )}
                          </td>
                          <td>
                            <Form.Check
                              type='switch'
                              name='aptcEligible'
                              id='aptcEligible'
                              checked={formData.personOne?.aptcEligible}
                              onChange={(e) => {
                                setFormData((p) => ({
                                  ...p,
                                  personOne: {...p.personOne, aptcEligible: e.target.checked},
                                }))
                              }}
                            />
                          </td>
                          {showMore && (
                            <>
                              <td className='show-more'>
                                <Form.Check
                                  type='switch'
                                  name='isParent'
                                  id='isParent'
                                  checked={formData.personOne?.isParent}
                                  onChange={(e) => {
                                    setFormData((p) => ({
                                      ...p,
                                      personOne: {...p.personOne, isParent: e.target.checked},
                                    }))
                                  }}
                                />
                              </td>

                              <td className='show-more'>
                                <Form.Check
                                  type='switch'
                                  name='hasMec'
                                  id='hasMec'
                                  checked={formData.personOne?.hasMec}
                                  onChange={(e) => {
                                    setFormData((p) => ({
                                      ...p,
                                      personOne: {...p.personOne, hasMec: e.target.checked},
                                    }))
                                  }}
                                />
                              </td>
                            </>
                          )}
                          <td> </td>
                        </tr>

                        {/* Mostrar los demás miembros (arrPeople) */}
                        {arrPeople.map((inf, idx) => (
                          <tr key={inf.id}>
                            <td>{idx + 2}</td>
                            <td>
                              <DateInput
                                id={`dob_${inf.id}`}
                                name="dob"
                                required={Boolean(!inf.age && !inf.dob)}
                                value={inf.dob}
                                onChange={(_, value) => {
                                  const ageC = calculateAge(value)
                                  setArrPeople((prevPeople) =>
                                    prevPeople.map((person) =>
                                      person.id === inf.id
                                        ? {
                                            ...person,
                                            dob: value,
                                            age: ageC ? `${ageC}` : '',
                                            hasMec: ageC && ageC < 19 ? true : false,
                                          }
                                        : person
                                    )
                                  )
                                }}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type='number'
                                name='Age'
                                className='input-age'
                                required={Boolean(!inf.age && !inf.dob)}
                                disabled={Boolean(inf.dob)}
                                value={inf.age}
                                onChange={(e) => {
                                  const {value} = e.target

                                  if (value === '') {
                                    setArrPeople((prevPeople) =>
                                      prevPeople.map((person) =>
                                        person.id === inf.id ? {...person, age: ''} : person
                                      )
                                    )
                                  }
                                  if (isNaN(Number(value))) return

                                  setArrPeople((prevPeople) =>
                                    prevPeople.map((person) =>
                                      person.id === inf.id
                                        ? {
                                            ...person,
                                            age: value,
                                            hasMec: Number(value) < 19 ? true : false,
                                          }
                                        : person
                                    )
                                  )
                                }}
                              />
                            </td>
                            <td>
                              <Form.Control
                                required
                                as='select'
                                name='gender'
                                value={inf.gender}
                                onChange={(e) => {
                                  const {value} = e.target
                                  setArrPeople((prevPeople) =>
                                    prevPeople.map((person) =>
                                      person.id === inf.id ? {...person, gender: value} : person
                                    )
                                  )
                                }}
                              >
                                {GENDER_OPTIONS.map(({value, label}) => (
                                  <option key={value} value={value}>
                                    {catalogGenderLabel(intl, value, label)}
                                  </option>
                                ))}
                              </Form.Control>
                            </td>
                            <td>
                              <Form.Group>
                                <Form.Check
                                  type='switch'
                                  // label='Is Pregnant'
                                  name='usesTobacco'
                                  id='usesTobacco'
                                  checked={inf.usesTobacco}
                                  onChange={(e) => {
                                    const {checked} = e.target
                                    setArrPeople((prevPeople) =>
                                      prevPeople.map((person) =>
                                        person.id === inf.id
                                          ? {...person, usesTobacco: checked}
                                          : person
                                      )
                                    )
                                  }}
                                />
                              </Form.Group>
                            </td>
                            <td>
                              <Form.Check
                                type='switch'
                                // label='Is Pregnant'
                                name='isPregnant'
                                id='isPregnant'
                                checked={inf.isPregnant}
                                onChange={(e) => {
                                  const {checked} = e.target
                                  setArrPeople((prevPeople) =>
                                    prevPeople.map((person) =>
                                      person.id === inf.id
                                        ? {...person, isPregnant: checked}
                                        : person
                                    )
                                  )
                                }}
                              />
                            </td>
                            <td>
                              <Form.Check
                                type='switch'
                                name='aptcEligible'
                                id={`aptcEligible_${inf.id}`}
                                checked={inf.aptcEligible}
                                onChange={(e) => {
                                  const {checked} = e.target
                                  setArrPeople((prevPeople) =>
                                    prevPeople.map((person) =>
                                      person.id === inf.id
                                        ? {...person, aptcEligible: checked}
                                        : person
                                    )
                                  )
                                }}
                              />
                            </td>
                            {showMore && (
                              <>
                                <td className='show-more'>
                                  <Form.Check
                                    type='switch'
                                    name='isParent'
                                    id={`isParent_${inf.id}`}
                                    checked={inf.isParent}
                                    onChange={(e) => {
                                      const {checked} = e.target
                                      setArrPeople((prevPeople) =>
                                        prevPeople.map((person) =>
                                          person.id === inf.id
                                            ? {...person, isParent: checked}
                                            : person
                                        )
                                      )
                                    }}
                                  />
                                </td>
                                <td className='show-more'>
                                  <Form.Check
                                    type='switch'
                                    name='hasMec'
                                    id={`hasMec${inf.id}`}
                                    checked={inf.hasMec}
                                    onChange={(e) => {
                                      const {checked} = e.target
                                      setArrPeople((prevPeople) =>
                                        prevPeople.map((person) =>
                                          person.id === inf.id
                                            ? {...person, hasMec: checked}
                                            : person
                                        )
                                      )
                                    }}
                                  />
                                </td>
                              </>
                            )}
                            <td>
                              <Button
                                variant='danger'
                                size='sm'
                                className='ms-2'
                                onClick={() => {
                                  setArrPeople((prev) =>
                                    prev.filter((person) => person.id !== inf.id)
                                  )
                                }}
                              >
                                <FormattedMessage id='common.action.delete' defaultMessage='Delete' />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
              <div className='mt-2'>
                <Button size='sm' variant='info' type='button' onClick={handleAddPeople}>
                  <FormattedMessage id='quotes.household.addPerson' defaultMessage='Add person' />
                </Button>
              </div>

              <Row className='mt-4'>
                {/* <Col lg={4}>
                            <Form.Group>
                              <Form.Label>Market</Form.Label>
                              <Form.Control
                                as='select'
                                name='market'
                                value={formData.market}
                                onChange={handleChange}
                              >
                                <option value='Individual'>Individual</option>
                              </Form.Control>
                            </Form.Group>
                          </Col> */}
              </Row>
            </div>
            <div className='d-flex align-items-center justify-content-end my-5 gap-3'>
              <Button variant='secondary' type='button' onClick={() => navigate(-1)}>
                <FormattedMessage id='quotes.household.back' defaultMessage='Back' />
              </Button>
              <Button variant='primary' type='submit'>
                <FormattedMessage id='common.action.search' defaultMessage='Search' />
              </Button>
            </div>
          </Form>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}
